import axios from "axios";
  
export default (beforeSend, afterResponse) => {
  // let token = sessionStorage.getItem("token");
  const token = "X9274jxlsfK8267jMztQ";

  const instance = axios.create({
    baseURL: "https://admin.psggo.com/api",
    // baseURL: "http://admin.staging-psggo.com/api",
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });

  if (beforeSend) {
    // Add a request interceptor
    instance.interceptors.request.use(function (config) {
      // Do something before request is sent
      beforeSend();
      return config;
    }, function (error) {
      // Do something with request error
      return Promise.reject(error);
    });
  }

  if (afterResponse) {
    // Add a response interceptor
    instance.interceptors.response.use(function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      afterResponse();
      return response;
    }, function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    });
  }

  return instance;
}
